import styled from '@emotion/styled';

export const GoogleWrapper = styled.div`
  height: 40px;
  margin: ${(props) => props.theme.spacing(1.5)} 0};
`;
